import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import ddt from '@wix/da-ddt';
import PopoverMenu from '../../../Menu/PopoverMenu';
import TrophyIcon from '../../../Icons/Trophy';
import UserAvatar from '../../../User/Avatar';
import UserLink from '../../../User/Link';
import Timestamp from '../../../Timestamp';
import { IconSize } from '../../../Icons/IconWrap';
import { MenuItem } from '../../../Menu';
import { actionMenuWidthMobile, actionMenuWidthDesktop } from '../../constants';
import { withMobileContext } from '../../../Context';
import { withCommentContext, } from '../CommentContext/CommentContext';
import { BiLoggerContextProvider } from '../../../biLogger';
import s from '../../Comment.scss';
var CommentHeader = /** @class */ (function (_super) {
    tslib_1.__extends(CommentHeader, _super);
    function CommentHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClickActionMenu = function () {
            var _a = _this.props, setActionMenuOpen = _a.setActionMenuOpen, isActionMenuOpen = _a.isActionMenuOpen;
            setActionMenuOpen(!isActionMenuOpen);
        };
        _this.hideActionMenu = function () {
            var setActionMenuOpen = _this.props.setActionMenuOpen;
            setActionMenuOpen(false);
        };
        _this.onToggleHide = function () {
            if (!_this.props.comment.isHidden) {
                _this.props.onHide && _this.props.onHide(_this.props.comment);
            }
            else {
                _this.props.onUnhide && _this.props.onUnhide(_this.props.comment);
            }
        };
        _this.onSelectAction = function (value) {
            var _a = _this.props, comment = _a.comment, onReportSpam = _a.onReportSpam, onFeature = _a.onFeature, onUnfeature = _a.onUnfeature, onBlockUser = _a.onBlockUser, isFeatured = _a.comment.isFeatured, setActionMenuOpen = _a.setActionMenuOpen;
            switch (value) {
                case 'spam':
                    // setTimeout allows actionmenu to be hidden before confirm prompt is shown
                    setTimeout(function () {
                        ddt.log('comments', 'reporting spam', comment);
                        if (confirm('Report this comment as spam?') && onReportSpam) {
                            onReportSpam(comment);
                        }
                    }, 100);
                    break;
                case 'delete':
                    ddt.log('comments', 'delete', comment);
                    _this.onToggleHide();
                    break;
                case 'feature':
                    if (onUnfeature && isFeatured) {
                        ddt.log('comments', 'unfeaturing', comment);
                        onUnfeature(comment);
                    }
                    if (onFeature && !isFeatured) {
                        onFeature(comment);
                    }
                    break;
                case 'hide':
                    _this.onToggleHide();
                    break;
                case 'block':
                    // setTimeout allows actionmenu to be hidden before confirm prompt is shown
                    setTimeout(function () {
                        if (confirm('Add this user to your block list?') && onBlockUser) {
                            onBlockUser(comment.user.userId);
                        }
                    });
                    break;
                default:
            }
            setActionMenuOpen(false);
        };
        return _this;
    }
    CommentHeader.prototype.render = function () {
        var _a = this.props, comment = _a.comment, t = _a.t, _b = _a.comment, isFeatured = _b.isFeatured, isSpam = _b.isSpam, showActions = _a.showActions, showAvatar = _a.showAvatar, showAuthorInfo = _a.showAuthorInfo, isMobile = _a.isMobile, isCommentVisible = _a.isCommentVisible;
        if (!isCommentVisible) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(BiLoggerContextProvider, { value: { sectionname: 'comments' } },
                showAvatar && (React.createElement(UserAvatar, { user: comment.user, className: classnames(s['avatar'], s['avatar-small']) })),
                showAuthorInfo && (React.createElement("div", { className: s['info'] },
                    React.createElement(UserLink, { user: comment.user, className: s['userlink'] }),
                    !isMobile && this.renderTime(comment),
                    this.renderAuthorInfo(comment)))),
            showActions &&
                (comment.isAuthor || comment.isOwner) &&
                !isSpam &&
                this.renderActionsMenu(),
            isFeatured && (React.createElement("span", { className: s['featured'] },
                React.createElement(TrophyIcon, { size: IconSize.MEDIUM, className: s['featured-icon'] }),
                t('comment.visibility.featured')))));
    };
    CommentHeader.prototype.renderTime = function (comment) {
        var t = this.props.t;
        var isEdited = !!comment.edited;
        var timestamp = isEdited ? comment.edited : comment.posted;
        return (React.createElement(React.Fragment, null,
            React.createElement("a", { key: "comment-link", href: Url.commentLink(comment.typeId, comment.itemId, comment.commentId), className: s['timestamp'] },
                isEdited && t('comment.info.edited') + " ",
                React.createElement(Timestamp, { timestamp: timestamp, isCapitalized: !isEdited }))));
    };
    CommentHeader.prototype.renderAuthorInfo = function (comment) {
        var isNewDeviant = comment.user.isNewDeviant;
        var info = isNewDeviant
            ? this.props.t('comment.info.newDeviant')
            : comment.authorInfo;
        // tslint:disable jsx-wrap-multiline
        return (info && (React.createElement("span", { key: "info", className: s['authorinfo'] },
            React.createElement("span", { className: s['separator'] }, "|"),
            info)));
    };
    CommentHeader.prototype.renderActionsMenu = function () {
        var _a = this.props, t = _a.t, _b = _a.comment, isFeatured = _b.isFeatured, isHidden = _b.isHidden, isOwner = _b.isOwner, isAuthor = _b.isAuthor, isReportable = _b.isReportable, isActionMenuOpen = _a.isActionMenuOpen, isMobile = _a.isMobile;
        return ((isOwner || isAuthor || isReportable) && (React.createElement("div", { className: s['actions-menu'], onClick: this.onClickActionMenu },
            React.createElement(PopoverMenu, { placement: isMobile ? 'topright' : 'top', isOpen: isActionMenuOpen, width: isMobile ? actionMenuWidthMobile : actionMenuWidthDesktop, onSelect: this.onSelectAction, onClickOutside: this.hideActionMenu, contentClassName: s['actions-menu-items'] },
                isOwner && (React.createElement(MenuItem, { className: s['actions-menu-item'], value: "feature" },
                    isMobile && !isFeatured && t('comment.popover.feature.mobile'),
                    isMobile &&
                        isFeatured &&
                        t('comment.popover.unfeature.mobile'),
                    !isMobile && !isFeatured && t('comment.popover.feature'),
                    !isMobile && isFeatured && t('comment.popover.unfeature'))),
                (isOwner || isAuthor) && (React.createElement(MenuItem, { className: s['actions-menu-item'], value: "delete" },
                    !isMobile && (!isHidden && t('comment.popover.delete')),
                    isMobile && (!isHidden && t('comment.popover.delete')))),
                isOwner && !isAuthor && (React.createElement(MenuItem, { className: s['actions-menu-item'], value: "block" },
                    !isMobile && t('comment.popover.block'),
                    isMobile && t('comment.popover.block.mobile'))),
                isReportable && !isAuthor && (React.createElement(MenuItem, { className: s['actions-menu-item'], value: "spam" },
                    !isMobile && t('comment.popover.report'),
                    isMobile && t('comment.popover.report.mobile')))),
            "...")));
    };
    CommentHeader.defaultProps = {
        showAuthorInfo: true,
    };
    return CommentHeader;
}(React.Component));
export default withCommentContext(withMobileContext(withTranslation()(CommentHeader)));
//# sourceMappingURL=CommentHeader.js.map